<script>
	import { link } from "svelte-spa-router";

	import Button from "./ui/Button.svelte";
	import Counter from "./ui/Counter.svelte";
	import Radio from "./ui/Radio.svelte";
	import { supports, buyLink, buyPrice } from "./data";

	import { licenses } from "./data.js";
	const list = licenses.map(a => ({ ...a }));

	let height = "20rem";
	function changeSupport(e, now) {
		const { value } = e.detail;
		if (value === now.support) return;

		now.support = value;
		now.price = buyPrice(now);
		list = list;

		// const expand = list.filter(a => a.support == "priority").length > 1;
		// height = expand ? "30rem" : "auto";
	}

	function changeDevs(e, now) {
		const { value } = e.detail;
		if (value === now.devs) return;

		now.devs = value;
		now.price = buyPrice(now);
		list = list;
	}

	function unlimited(value, word) {
		if (value === Infinity) return `<b>Unlimited</b>&nbsp;${word}s`;
		else if (value === 1) {
			return `One ${word}`;
		}

		return `${value.toString()} ${word}s`;
	}

	function toggleList(e) {
		e.target.classList.toggle("rotate");
		e.target.nextElementSibling.classList.toggle("hidden");
	}
</script>

<div class="block">
	<div class="table js-table">
		{#each list as obj}
			<div class="column">
				<span class="icon">
					<svelte:component this={obj.logo} />
				</span>
				<h2>{obj.name}</h2>
				{#if obj.id == 'custom'}
					<div class="cost">
						<span style="font-weight:400;">from</span>
						${obj.price}
					</div>
					<div class="line">&nbsp;</div>
					<div class="line">&nbsp;</div>
					<div class="line padded">{obj.descr}</div>
					<div class="button">
						<a href={'/preview-pack/' + obj.id} use:link>
							<Button label="Customize" width="80%" />
						</a>
					</div>
					<div class="line dotted">
						<a href={obj.licenseLink}>License Agreement</a>
					</div>
				{:else}
					<div class="cost">${obj.price}</div>
					<div class="line">
						{@html unlimited(obj.projects, 'Project')}
					</div>
					<div class="line">
						{#if obj.devs === Infinity}
							{@html unlimited(obj.devs, 'Developer')}
						{:else}
							<Counter
								value={obj.devs}
								min={obj._devs}
								max={obj.maxDevs}
								name="developer"
								on:change={e => changeDevs(e, obj)} />
						{/if}

					</div>
					<div class="line padded">{obj.descr}</div>
					<div class="button">
						<Button href={buyLink(obj)} label="Buy Now" width="80%" />
					</div>
					<div class="line dotted">
						<a href={obj.licenseLink}>License Agreement</a>
					</div>
					<div class="line dottedBottom flexCol">
						<span class="widgetsBtn rotate mh5" on:click={e => toggleList(e)}>
							{obj.widgets < Infinity ? 'Any ' + obj.widgets + ' complex widgets free of charge' : 'All complex widgets'}
						</span>
						<ul class="widgetsList hidden">
							<li>Pivot</li>
							<li>File Manager + Doc Manager</li>
							<li>Kanban</li>
							<li>Query</li>
							<li>Scheduler</li>
							<li>User Manager</li>
							<li>Chat / Messenger</li>
							<li>SpreadSheet</li>
							<li>Gantt Chart</li>
							<li>Report Manager</li>
							<li>Diagram Library</li>
							<li>To Do List</li>
							<li>Desktop</li>
						</ul>
					</div>

					<div class="line bottom" style="min-height:{height}">
						<ul>
							{#if obj.supportOptions.length}
								<Radio
									line={true}
									value={obj.support}
									on:change={e => changeSupport(e, obj)}
									options={obj.supportOptions.map(a => supports[a])} />
							{/if}

							<li>
								Up to {supports[obj.support].hours} hours initial response time
							</li>

							{#if obj.support === 'priority'}
								<li>Unlimited number of tickets</li>
								<li>10 live chat sessions</li>
								<li>Emergency bug fixes</li>
								<li>Integration audit</li>
							{:else}
								<li>
									{supports[obj.support].tickets} tickets / Unlimited 1st month
								</li>
							{/if}
						</ul>
					</div>
				{/if}
			</div>
		{/each}
	</div>
</div>

<style>
	.flexCol {
		flex-direction: column;
	}
	li {
		padding-left: 1.5rem;
		margin: 0 2rem;
		text-align: left;
		position: relative;
		line-height: 2;
	}
	li:before {
		content: "";
		display: block;
		width: 0.3rem;
		height: 0.3rem;
		border-radius: 50%;
		background-color: rgba(0, 0, 0, 0.7);
		position: absolute;
		left: 0;
		top: 1.4rem;
	}

	.block {
		font-family: Roboto;
	}
	.table {
		display: flex;
	}
	.column {
		text-align: center;
		border: 1px solid #dedede;
		padding: 5rem 0 1rem;
		position: relative;
		overflow: hidden;
		flex: 1;
	}
	.column:not(:last-of-type) {
		border-right: none;
	}
	.icon {
		display: inline-block;
		width: 65px;
		height: 65px;
	}
	h2 {
		font-size: 2rem;
		line-height: 2.5rem;
		font-weight: 500;
		text-transform: uppercase;
		margin-top: 1.7rem;
	}
	.cost {
		font-size: 3rem;
		line-height: 3.5rem;
		font-weight: 500;
		color: #7e57c2;
		padding-bottom: 0.2rem;
		margin-bottom: 1.7rem;
		margin-top: 3.3rem;
		padding-left: 1.8rem;
		padding-right: 1.8rem;
		position: relative;
	}
	.line {
		font-size: 1.6rem;
		line-height: 2.5rem;
		min-height: 3.5rem;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.7);

		display: flex;
		justify-content: center;
	}
	.padded {
		margin: 2rem 2rem 0 2rem;
		min-height: 8rem;
	}
	.bottom {
		flex-direction: column;
		justify-content: space-between;
	}
	.dotted {
		margin: 2rem 0;
		padding: 2rem;

		background: #fff;
		background: linear-gradient(to right, #9e9e9e 10%, #ffffff 0%),
			linear-gradient(to right, #9e9e9e 10%, #ffffff 0%);
		background-repeat: repeat-x;
		background-size: 7px 1px;
		background-position: top, bottom;
	}
	.dottedBottom {
		margin: 0 0 2rem;
		padding: 0 2rem 2rem;

		background: #fff;
		background: linear-gradient(to right, #9e9e9e 10%, #ffffff 0%),
			linear-gradient(to right, #9e9e9e 10%, #ffffff 0%);
		background-repeat: repeat-x;
		background-size: 7px 1px;
		background-position: bottom;
	}
	ul {
		min-height: 15rem;
		max-width: max-content;
		margin: 0 auto;
	}
	.button {
		display: block;
		margin-bottom: 2rem;
	}
	.mh5 {
		min-height: 5rem;
	}
	.widgetsBtn {
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-right: 2rem;
		position: relative;
		max-width: max-content;
		margin: auto;
	}
	.widgetsBtn:after {
		content: "";
		display: block;
		width: 0;
		height: 0;
		position: absolute;
		right: 0.1px;
		top: 50%;
		margin-top: -0.1rem;
		border-width: 0.5rem 0.5rem 0 0.5rem;
		border-style: solid;
		border-color: rgba(0, 0, 0, 0.7) transparent;
		transform: rotate(0deg);
	}
	.widgetsBtn.rotate:after {
		transform: rotate(-180deg);
	}
	.widgetsList {
		padding-top: 2rem;
		columns: 2;
	}
	.widgetsList.hidden {
		display: none;
	}
	@media screen and (max-width: 1440px) {
		.widgetsList {
			columns: initial;
		}
	}
	@media screen and (max-width: 1180px) {
		.table {
			flex-wrap: wrap;
		}
		.column {
			width: 50%;
			flex: initial;
		}
		.column:nth-of-type(2),
		.column:nth-of-type(4) {
			border-right: 1px solid rgb(222, 222, 222);
		}
		.column:nth-of-type(1),
		.column:nth-of-type(2) {
			border-bottom: none;
		}
	}
	@media screen and (max-width: 660px) {
		.column {
			width: 100%;
			border-bottom: none;
		}
		.column:not(:last-child) {
			border-right: 1px solid rgb(222, 222, 222);
		}
		.column:nth-of-type(2),
		.column:nth-of-type(3) {
			border-bottom: inherit;
		}
		.column:last-of-type {
			border-bottom: 1px solid rgb(222, 222, 222);
			border-right: 1px solid rgb(222, 222, 222);
		}
	}
</style>
